import type { FobsMasterData, IncidentFob, IncidentFobType } from '@/types/Fobs'

import ky from './httpService'

export const getFobsMasterData = async (): Promise<FobsMasterData> => {
  const URI = 'api/fobs/masterData'
  const fobsMasterData: FobsMasterData = await ky.get(URI, {}).json()
  // Order spread and spots
  fobsMasterData.spreadTypes.sort((a, b) => a.displayOrder - b.displayOrder)
  fobsMasterData.spottingTypes.sort((a, b) => a.displayOrder - b.displayOrder)
  // return the data ordered
  return fobsMasterData
}

export const saveObservation = async (payload: IncidentFobType): Promise<IncidentFob> => {
  const URI = 'api/fobs/'

  return await ky.post(URI, { json: payload }).json()
}

export const getObservations = async (incidentId: string): Promise<Array<IncidentFob>> => {
  const URI = `api/fobs/`

  const searchParams = new URLSearchParams()
  searchParams.append('incidentId', incidentId)

  return await ky.get(URI, { searchParams }).json()
}
